import { render } from "./noteMessage.vue?vue&type=template&id=ad28d908&scoped=true"
import script from "./noteMessage.vue?vue&type=script&lang=js"
export * from "./noteMessage.vue?vue&type=script&lang=js"

import "./noteMessage.vue?vue&type=style&index=0&id=ad28d908&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad28d908"]])

export default __exports__